// @mui icons
import Icon from "@mui/material/Icon";

// Pages
import UserProfile from "./user/profile";
import Dashboard from "./dashboard";
// import DispenseVoucher from "./transact/dispense";
// import OnboardCustomer from "./transact/onboard";
// import History from "./transact/history";
import SellProduct from "./transact/sell";
import Commissions from "./campaigns/commissions";
import Wallet from "./wallet";
import AffiliateLinks from "./campaigns/affiliate_links";
// import Campaigns from "./transact/campaigns";
import Orders from "./transact/orders";
import MyCampaigns from "./campaigns/my_campaigns";
// import TeleSalesCampaigns from "./telemarketing";
import Organisations from "./teams/organisations";
import Inbox from "./inbox";
import Courses from "./trainings/courses";
import CourseCertificates from "./trainings/certificates";
// import Gigs from "./gigs";
// import AgentWebStore from "./webstore";
// import PromoteIndex from "./social/promote";
// import Products from "./gigs/products";
import CheckInRequestsPage from "./check_ins";
import DataCollectionPage from "./transact/data_capture";
// import CampaignAttendancesPage from "./attendances";
import AttendancesPage from "./attendances";
import GPSCameraPage from "./tools/gps_camera";
import LeadBucketsPage from "./leads/buckets";
import DawActivationsPage from "./activations/daw";
import CampaignsIndexPage from "./campaigns";
import TasksPage from "./dashboard/tasks";
import CallCentersPage from "./call_center";
import VisitTrackerLocationsPage from "./visits/locations";
import VisitTrackersPage from "./visits/trackers";
import OpsAccountsPage from "./ops/accounts";
import InventoryAssignmentsPage from "./inventory";
// import SocialHomePage from "./social";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "field",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/field",
    component: <Dashboard />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Organisations",
    key: "ops",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/ops",
    component: <OpsAccountsPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Tasks",
    key: "tasks",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/tasks",
    component: <TasksPage />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Inventory",
    key: "inventories",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/inventories",
    component: <InventoryAssignmentsPage />,
    secure: true,
  },
  // {
  //   type: "collapse",
  //   name: "Location Visits",
  //   key: "visits",
  //   icon: <Icon fontSize="small">tour</Icon>,
  //   route: "/visits",
  //   component: <VisitTrackersPage />,
  //   secure: true,
  // },
  {
    type: "divider",
    name: "Divider",
  },
  // {
  //   type: "collapse",
  //   name: "Sales Teams",
  //   key: "campaigns",
  //   icon: <Icon fontSize="small">money_bag</Icon>,
  //   route: "/gigs",
  //   component: <Gigs />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Campaigns",
  //   key: "my-campaigns",
  //   icon: <Icon fontSize="small">list</Icon>,
  //   route: "/my-campaigns",
  //   component: <MyCampaigns />,
  //   secure: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Sell Links",
  //   key: "affiliate-links",
  //   icon: <Icon fontSize="small">link</Icon>,
  //   route: "/affiliate-links",
  //   component: <AffiliateLinks />,
  //   secure: true,
  // },
  // {
  //   type: "divider",
  //   name: "Divider",
  // },
  {
    type: "collapse",
    name: "Attendance",
    key: "attendance",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/attendance",
    component: <AttendancesPage />,
    secure: true,
  },
  // {
  //   type: "collapse",
  //   name: "Check-In",
  //   key: "location-check-in",
  //   icon: <Icon fontSize="small">person_pin</Icon>,
  //   route: "/location-check-in",
  //   component: <CheckInRequestsPage />,
  //   secure: true,
  // },
  {
    type: "collapse",
    name: "Leads",
    key: "lead-buckets",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/lead-buckets",
    component: <LeadBucketsPage />,
    secure: true,
  },

  {
    type: "collapse",
    name: "GPS Camera",
    key: "gps-camera",
    icon: <Icon fontSize="small">camera_alt</Icon>,
    route: "/gps-camera",
    component: <GPSCameraPage />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Trainings",
    key: "courses",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/courses",
    component: <Courses />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Certificates",
    key: "courses/certificates",
    icon: <Icon fontSize="small">workspace_premium</Icon>,
    route: "/courses/certificates",
    component: <CourseCertificates />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Groups",
    key: "organisations",
    icon: <Icon fontSize="small">workspaces</Icon>,
    route: "/organisations",
    component: <Organisations />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Sales History",
    key: "history",
    icon: <Icon fontSize="small">list</Icon>,
    route: "/history",
    component: <Orders />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Commissions",
    key: "commissions",
    icon: <Icon fontSize="small">wallet</Icon>,
    route: "/commissions",
    component: <Commissions />,
    secure: true,
  },
  {
    type: "divider",
    name: "Divider",
  },
  {
    type: "collapse",
    name: "Inbox",
    key: "messages",
    icon: <Icon fontSize="small">mail</Icon>,
    route: "/messages",
    component: <Inbox />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Wallet",
    key: "wallet",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/wallet",
    component: <Wallet />,
    secure: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <UserProfile />,
    secure: true,
  },
];

export default routes;
